<template>
  <div class="cooperative-school">
    <el-form size="mini" :inline="true" class="form1" @submit.native.prevent>
      <el-form-item label="学校名称:">
        <el-input placeholder="请输入学校名称" v-model="ruleForm.educational_institution_name" @keyup.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="平台账号:">
        <el-input placeholder="请输入平台账号" v-model="ruleForm.username" @keyup.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="二级域名">
        <el-input placeholder="请输入二级域名" v-model="ruleForm.domain" clearable @keyup.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item>
        <el-form-item label="体验科目:">
          <el-select v-model="ruleForm.subjectIds" filterable multiple placeholder="请选择科目" @change="search">
            <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="负责人:">
          <el-input placeholder="请输入负责人" v-model="ruleForm.authUserName" clearable @keyup.enter.native="search"></el-input>
        </el-form-item>
        <el-button @click="search" type="primary">查询</el-button>
      </el-form-item>
      <br />

      <el-button size="mini" @click="addSchool" type="primary" icon="el-icon-plus">新增体验校区</el-button>
    </el-form>
    <div class="table-style">
      <el-table size="small" :data="tableData" :header-cell-style="{ background: '#f5f7fa', color: '#909399' }" stripe>
        <el-table-column width="50" align="center" prop="id" label="序号" fixed="left">
          <template slot-scope="scope">{{
            scope.$index + 1 + 20 * (page_no - 1)
          }}</template>
        </el-table-column>

        <el-table-column align="left" label="校区名称" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>
              {{ scope.row.name }}
            </span>
          </template>
        </el-table-column>
        <el-table-column width="150" align="left" label="二级域名">
          <template slot-scope="scope">
            <el-link type="info">
              {{ scope.row.domain }}
            </el-link>
          </template>
        </el-table-column>

        <!--
        <el-table-column align="left" label="二级域名">
          <template slot-scope="scope">
            <el-link @click="GogoSchool(scope.row.domain)" type="info">
              {{ scope.row.domain }}
            </el-link>
          </template>
        </el-table-column>
-->
        <el-table-column label="体验科目" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>
              {{ scope.row.subject }}
            </span>
          </template>
        </el-table-column>

        <!--

        <el-table-column width="200" align="left" label="地区">
          <template slot-scope="scope">
            <span>{{ scope.row.province }}-</span>
            <span>{{ scope.row.city }}-</span>
            <span>{{ scope.row.area }}</span>
          </template>
        </el-table-column>

        -->

        <el-table-column align="left" label="真实姓名">
          <template slot-scope="scope">
            <span v-for="item of scope.row.principalList" :key="item.id">
              <span>{{ item.realname }}</span>
            </span>
          </template>
        </el-table-column>

        <el-table-column align="left" label="平台账号" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-for="item of scope.row.principalList" :key="item.id">
              <span>{{ item.name }}</span>
            </span>
          </template>
        </el-table-column>

        <!--

        <el-table-column width="150" align="left" label="已用空间">
          <template slot-scope="scope">
            <span v-if="
                scope.row.use_storage >= 1024 && scope.row.use_storage < 1048576
              ">
              {{ parseFloat(scope.row.use_storage / 1024).toFixed(2) }}
              MB
            </span>
            <span v-else-if="scope.row.use_storage < 1024">{{ scope.row.use_storage }} KB</span>
            <span v-else>
              {{ parseFloat(scope.row.use_storage / 1024 / 1024).toFixed(2) }}
              GB
            </span>
          </template>
        </el-table-column>

        <el-table-column width="150" align="left" label="总空间">
          <template slot-scope="scope">
            <span v-if="
                scope.row.total_storage >= 1024 &&
                scope.row.total_storage < 1048576
              ">
              {{ parseFloat(scope.row.total_storage / 1024).toFixed(2) }}
              MB
            </span>
            <span v-else-if="scope.row.total_storage < 1024">{{ scope.row.total_storage }} KB</span>
            <span v-else>
              {{ parseFloat(scope.row.total_storage / 1024 / 1024).toFixed(2) }}
              GB
            </span>
          </template>
        </el-table-column>

        <el-table-column width="150" align="left" label="剩余流量">
          <template slot-scope="scope">
            <span v-if="
                scope.row.remain_traffic >= 1024 &&
                scope.row.remain_traffic < 1048576
              ">
              {{ parseFloat(scope.row.remain_traffic / 1024).toFixed(2) }}
              MB
            </span>
            <span v-else-if="scope.row.remain_traffic < 1024">{{ scope.row.remain_traffic }} KB</span>
            <span v-else>
              {{
              parseFloat(scope.row.remain_traffic / 1024 / 1024).toFixed(2)
              }}
              GB
            </span>
          </template>
        </el-table-column>

        -->

        <el-table-column align="left" prop="stu_remain_time" label="剩余时长(天)"></el-table-column>

        <!-- <el-table-column width="150" align="left" label="客户标签">
          <template slot-scope="scope">
            <el-tag size="mini" v-for="item in scope.row.schoolTagArr" :key="item.id" :color="item.tagInfo.color">
              <span style="color: white">{{ item.tagInfo.name }}</span>
            </el-tag>
          </template>
        </el-table-column> -->

        <!--
        <el-table-column width="80" align="center" label="题库权限">
          <template slot-scope="scope">
            <el-tag size="mini" type="success" effect="dark" v-if="scope.row.question_bank_permission"></el-tag>
            <el-tag size="mini" v-else type="info" effect="dark"></el-tag>
          </template>
        </el-table-column>
        <el-table-column label="科目权限" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>
              {{scope.row.subject}}
            </span>
          </template>
        </el-table-column>

        <el-table-column width="500" align="center" label="公众平台授权">
          <template slot-scope="scope">
            <span v-if="scope.row.is_authorize">
              <span class="wechat_name" v-if="
                  scope.row.authorizer_service_type_info == 0 ||
                  scope.row.authorizer_service_type_info == 1
                ">{{ scope.row.name }}-订阅号</span>
              <span class="wechat_name" v-else-if="scope.row.authorizer_service_type_info == 2">{{ scope.row.authorizer_nick_name }}-服务号</span>

              <span class="wechat_label" style="margin-left: 10px">
                <span v-if="scope.row.authorizer_verify_type_info == -1">未认证</span>
                <span style="color: green" v-else>已认证</span>
              </span>
              <br />
              <span style="margin-left: 10px; color: #409eff; cursor: pointer" @click="getIndustry(scope.row)">查看行业</span>
              <span style="margin-left: 10px; color: #409eff; cursor: pointer" @click="getTemplateList(scope.row)">查看模板</span>
              <span style="margin-left: 10px; color: #409eff; cursor: pointer" @click="addTemplates(scope.row)">同步模板</span>
            </span>
          </template>
        </el-table-column>

        -->

        <el-table-column align="left" prop="authUserInfo.realname" label="负责人">
        </el-table-column>

        <el-table-column fixed="right" width="150" align="left" prop="created_time" label="创建日期">
        </el-table-column>

        <el-table-column fixed="right" width="150" align="left" prop="off_time" label="到期时间">
        </el-table-column>

        <el-table-column align="center" width="250" prop="name" label="操作" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="updateInfo(scope.row)">编辑</el-button>

            <el-button type="text" size="small" @click="LookUses(scope.row)">使用情况</el-button>
            <el-button type="text" size="small" @click="tch(scope.row)">校长信息</el-button>
            <el-button type="text" size="small" @click="changeCooperation(scope.row)">一键修改</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-style">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="page_no" :page-size="20" layout="total, prev, pager, next" :total="total"></el-pagination>
    </div>
    <el-dialog title="修改学校信息" :visible.sync="dialogVisible" width="600px">
      <el-form class="form-style" ref="form" :model="form" :rules="rules" label-width="100px" label-position="center" size="small">
        <el-form-item label="学校名称" required prop="educational_institution_name">
          <el-input placeholder="请输入学校名称" v-model="form.educational_institution_name" style="width: 400px"></el-input>
        </el-form-item>

        <el-form-item label="二级域名" required prop="domain">
          <el-input placeholder="请输入二级域名" v-model="form.domain" style="width: 400px"></el-input>
        </el-form-item>

        <el-form-item label="体验科目" required prop="subjectIds">
          <el-select v-model="form.subjectIds" filterable multiple placeholder="请选择科目" style="width: 400px">
            <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="截止日期" required prop="off_time">
          <el-date-picker style="width: 400px" v-model="form.off_time" type="date" placeholder="请选择系统截止日期" value-format="yyyy-MM-dd" placement="bottom-start"></el-date-picker>
        </el-form-item>

        <el-form-item label="备注信息">
          <el-input placeholder="请输入学校备注" v-model="form.remarks" style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="赛考中心">
          <el-switch v-model="form.question_bank_permission"></el-switch>
        </el-form-item>
        <el-form-item label="信奥专区">
          <el-switch v-model="form.oj_permission"></el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="quitDialog">取 消</el-button>
        <el-button size="small" type="primary" @click="submit('form')">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="新增体验学校" :visible.sync="dialogVisible1" width="60%">
      <el-form class="form-style" ref="form1" :model="form1" :rules="rules" label-width="100px" label-position="left" size="small">
        <el-form-item label="学校名称" required prop="school_name">
          <el-input placeholder="请输入学校名称" v-model="form1.school_name" style="width: 400px"></el-input>
        </el-form-item>

        <el-form-item label="二级域名" required prop="domain">
          <el-input placeholder="请输入二级域名" v-model="form1.domain" style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="截止日期" required prop="off_time">
          <el-date-picker v-model="form1.off_time" type="date" placeholder="请选择系统截止日期" value-format="yyyy-MM-dd" placement="bottom-start"></el-date-picker>
        </el-form-item>
        <el-form-item label="设置套餐">
          <el-select v-model="form1.meal_id">
            <el-option v-for="item in mealOptions" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="平台账号" required prop="username">
          <el-input placeholder="请输入平台账号" v-model="form1.username" style="width: 400px"></el-input>
          <el-tooltip class="item" effect="dark" :content="`账号为6-20位字母或数字组成,不能包含特殊字符,推荐以手机号作为平台账号,密码为${form1.domain}123456`" placement="top">
            <i style="margin-left: 10px" class="el-icon-question"></i>
          </el-tooltip>
        </el-form-item>
        <el-form-item label="真实姓名" required prop="realname">
          <el-input placeholder="请输入真实姓名" v-model="form1.realname" style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="体验科目" required prop="subjectIds">
          <el-select v-model="form1.subjectIds" filterable multiple placeholder="请选择科目" style="width: 250px">
            <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="赛考中心">
          <el-switch v-model="form1.question_bank_permission"></el-switch>
        </el-form-item>
        <el-form-item label="信奥专区">
          <el-switch v-model="form1.oj_permission"></el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="quitDialog1">取 消</el-button>
        <el-button size="small" type="primary" @click="submit1('form1')">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="修改账号信息" :visible.sync="dialogVisible3" width="50%">
      <el-form class="form-style" ref="form" :model="form2" :rules="rules" label-width="100px" label-position="left" size="small">
        <el-form-item label="真实姓名" required prop="realname">
          <el-input placeholder="请输入真实姓名" v-model="form2.realname" style="width: 400px">
          </el-input>
        </el-form-item>

        <el-form-item label="账号" required prop="username">
          <el-input placeholder="请输入账号" v-model="form2.username" style="width: 400px">
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible3 = false">取 消</el-button>
        <el-button size="small" type="primary" @click="updatePrincipalUserInfo">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  updatePrincipalUserInfo,
  getEducationalInstitutionList,
  //   addEducationalInstitution,
  updateTrySchool,
  getPrincipalUserList,
  adminGetSchoolTagList,
  getIndustry,
  getTemplateList,
  addTemplates,
  addTrySchool,
  getSubjectList,
  adminChangeTrySchoolDomainAndHeadmast,
} from '@/api/admin'

//import myDistrict from "../../../../components/myDistrict/myDistrict.vue";
import {
  api_mealQueryValidList,
  //  api_eduMealEdit
} from '@/api/javaApi'

export default {
  name: 'cooperative-school',
  data() {
    var validate_username = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入账号'))
      }
      if (!/^[a-zA-Z0-9]{6,20}$/.test(value)) {
        callback(new Error('账号必须为6-20位字母或数字组成'))
      } else {
        callback()
      }

      if (!this.checkSpecialKey(value)) {
        callback(new Error('不能含有特殊字符！！'))
      } else {
        callback()
      }
    }
    return {
      authUserInfoName: '',
      userList: [],
      dialogVisible3: false,
      dialogVisible: false,
      dialogVisible1: false,
      dialogVisible2: false,

      options: [
        {
          id: 1,
          label: 'Python',
        },
        {
          id: 2,
          label: 'Scratch',
        },
        {
          id: 3,
          label: 'Jrcode',
        },
      ],
      ruleForm: {
        authUserName: '',
        subjectIds: [],
        username: '',
        educational_institution_name: '',
      },
      form1: {
        subjectIds: [],
        school_name: '',
        domain: '',
        off_time: '',
        username: '',
        realname: '',
        question_bank_permission: true,
        oj_permission: true,
        meal_id: '',
      },
      userId: '',
      form2: {
        username: '',
        realname: '',
      },
      form: {
        subjectIds: [],

        educational_institution_name: '',
        domain: '',
        max_campus_num: 1,
        max_teacher_num: 1,
        max_student_num: 1,
        off_time: '',
        remarks: '',
        tagIds: [],
        province: '',
        city: '',
        area: '',
        question_bank_permission: false,
        oj_permission: false,

        username: '',
      },
      schoolId: '',
      schoolTagList: [], //标签页面
      tableData: [],
      total: 0,
      page_no: 1,
      rules: {
        subjectIds: [
          { required: true, message: '请选择科目', trigger: 'change' },
          {
            required: true,
            message: '请选择科目',
            trigger: 'blur',
          },
        ],
        school_name: [
          {
            required: true,
            message: '请输入学校名称',
            trigger: 'change',
          },
          {
            required: true,
            message: '请输入学校名称',
            trigger: 'blur',
          },
        ],
        username: [
          {
            validator: validate_username,
            trigger: 'blur',
          },
          {
            required: true,
            message: '请输入用户名',
            trigger: 'change',
          },
        ],
        realname: [
          {
            required: true,
            message: '请输入真实姓名',
            trigger: 'change',
          },
          {
            required: true,
            message: '请输入真实姓名',
            trigger: 'blur',
          },
        ],
        educational_institution_name: [
          {
            required: true,
            message: '请输入学校名称',
            trigger: 'change',
          },
          {
            required: true,
            message: '请输入学校名称',
            trigger: 'blur',
          },
        ],
        domain: [
          {
            validator: function (rule, value, callback) {
              if (/[a-z]$/.test(value) == false) {
                callback(new Error('请输入小写英文'))
              } else {
                //校验通过
                callback()
              }
            },
            trigger: 'blur',
          },
          {
            required: true,
            message: '请输入二级域名',
            trigger: 'change',
          },
        ],
        remarks: [
          {
            required: true,
            message: '请输入学校备注',
            trigger: 'change',
          },
          {
            required: true,
            message: '请输入学校备注',
            trigger: 'blur',
          },
        ],
        off_time: [
          { required: true, message: '请选择系统截止日期', trigger: 'change' },
          { required: true, message: '请选择系统截止日期', trigger: 'blur' },
        ],
        offset: 0,
      },
      mealOptions: [],
    }
  },

  //components: { myDistrict },

  mounted() {
    this.getEducationalInstitutionList()
    this.getPrincipalUserList()
    this.adminGetSchoolTagList()
    this.getUserSubjectList()
    this.adminMealGet()
  },
  methods: {
    //更新套餐

    adminMealGet() {
      api_mealQueryValidList({
        // page_no: 1,
        // page_size: 20,
      }).then((res) => {
        console.log('查询角色列表')
        console.log(res, 214545)
        this.mealOptions = res
        if (res.join('') !== '') {
          this.form1.meal_id = res[0].id
        }
      })
    },
    changeCooperation(row) {
      this.$confirm('确认在二级域名和账号前面加入ty吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          adminChangeTrySchoolDomainAndHeadmast({
            schoolId: row.id,
          })
          this.$message({
            type: 'success',
            message: '修改成功!',
          })
          this.getEducationalInstitutionList()
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          })
        })
    },
    LookUses(row) {
      this.$router.push({
        name: 'csm-grow',
        query: {
          school_name: row.name,
        },
      })
    },
    tch(row) {
      console.log(row)
      this.userId = row.principalList[0].id
      this.form2.realname = row.principalList[0].realname
      this.form2.username = row.principalList[0].name
      this.dialogVisible3 = true
    },
    updatePrincipalUserInfo() {
      let targetParams = {
        userId: this.userId,
        userName: this.form2.username,
        realName: this.form2.realname,
      };
      updatePrincipalUserInfo(targetParams).then((res) => {
        console.log('修改账号信息')
        console.log(res)
        this.$message.success('修改成功')
        this.getEducationalInstitutionList()
        this.dialogVisible3 = false
      })
    },

    getUserSubjectList() {
      getSubjectList({
        subject_state: '',
        page_size: 1000
      }).then((res) => {
        this.options = res.subject_list
      })
    },
    checkSpecialKey(str) {
      let specialKey =
        "[`~!#$^&*()=|{}':;'\\[\\].<>/?~！#￥……&*（）——|{}【】‘；：”“'。，、？]‘'"
      for (let i = 0; i < str.length; i++) {
        if (specialKey.indexOf(str.substr(i, 1)) != -1) {
          return false
        }
      }
      return true
    },

    //修改到期时间
    offTime(row) {
      console.log('更新学校信息')
      console.log(row)
      this.schoolId = row.id
      this.form.educational_institution_name = row.name
      this.form.domain = row.domain
      this.form.max_teacher_num = row.max_teacher_num
      this.form.max_student_num = row.max_student_num
      this.form.off_time = row.off_time
      this.form.remarks = row.remarks
      this.form.max_campus_num = row.max_campus_num

      this.form.question_bank_permission = row.question_bank_permission

      this.form.province = row.province
      this.form.city = row.city
      this.form.area = row.area

      this.form.tagIds = []
      for (let k = 0; k < row.schoolTagArr.length; k++) {
        this.form.tagIds.push(row.schoolTagArr[k].tagInfo.id)
      }

      //   this.dialogVisible = true;
      this.dialogVisible2 = true
    },
    //获得行业信息
    getIndustry(row) {
      console.log(row)
      getIndustry({
        schoolId: row.id,
      }).then((res) => {
        console.log('获得行业信息')
        console.log(res)
        if (res.industry_data.primary_industry) {
          this.$notify({
            title: '行业信息',
            message:
              res.industry_data.primary_industry.first_class +
              '-' +
              res.industry_data.primary_industry.second_class,
          })
        }

        if (res.industry_data.secondary_industry) {
          this.$notify({
            title: '行业信息',
            message:
              res.industry_data.secondary_industry.first_class +
              '-' +
              res.industry_data.secondary_industry.second_class,
            offset: 100,
          })
        }
      })
    },

    //获得模板列表
    getTemplateList(row) {
      getTemplateList({
        schoolId: row.id,
      }).then((res) => {
        console.log('获得模板列表')
        console.log(res)

        this.offset = 0
        for (let k = 0; k < res.templateList.length; k++) {
          this.$notify({
            title: res.templateList[k].title,
            message: res.templateList[k].template_id,
            offset: this.offset,
          })

          this.offset = this.offset + 100
        }
      })
    },

    //同步模板消息
    addTemplates(row) {
      if (row.wxTemplateArr.length > 0) {
        this.$confirm('已同步过模板消息,确定重新同步吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          addTemplates({
            schoolId: row.id,
          }).then((res) => {
            console.log('同步模板列表')
            console.log(res)

            if (res.is_create) {
              this.$message.success('同步成功')
            }
          })
        })
      } else {
        addTemplates({
          schoolId: row.id,
        }).then((res) => {
          console.log('同步模板列表')
          console.log(res)

          if (res.is_create) {
            this.$message.success('同步成功')
          }
        })
      }
    },

    //查询校区标签
    adminGetSchoolTagList() {
      adminGetSchoolTagList().then((res) => {
        console.log('查询校区标签')
        console.log(res)
        this.schoolTagList = res.schoolTagList
      })
    },

    // 获取校长账号列表
    getPrincipalUserList() {
      getPrincipalUserList({
        page_size: 200,
      }).then((res) => {
        this.userList = res.principal_user_list
      })
    },
    // 修改信息
    updateInfo(row) {
      console.log('更新学校信息')
      console.log(row)
      this.schoolId = row.id
      this.form.educational_institution_name = row.name
      this.form.domain = row.domain
      this.form.max_teacher_num = row.max_teacher_num
      this.form.max_student_num = row.max_student_num
      this.form.off_time = row.off_time
      this.form.remarks = row.remarks
      this.form.max_campus_num = row.max_campus_num
      this.form.oj_permission = row.oj_permission

      this.form.question_bank_permission = row.question_bank_permission
      this.form.username = row.principalList[0].name
      console.log(row.principalList)

      this.form.province = row.province
      this.form.city = row.city
      this.form.area = row.area

      this.form.tagIds = []
      for (let k = 0; k < row.schoolTagArr.length; k++) {
        this.form.tagIds.push(row.schoolTagArr[k].tagInfo.id)
      }
      this.form.subjectIds = []
      for (let k = 0; k < row.schoolSubjectAuthArr.length; k++) {
        this.form.subjectIds.push(row.schoolSubjectAuthArr[k].subjectInfo.id)
      }

      this.dialogVisible = true
    },

    AddFiles(row) {
      console.log('下载中心')
      this.$router.push({
        name: 'download-management',
        query: {
          id: row.id,
        },
      })
    },

    AddSubject(row) {
      console.log('科目授权')
      this.$router.push({
        name: 'school-subject-permissions',
        query: {
          id: row.id,
          off_time: row.off_time,
          domain: row.domain,
          name: row.name,
        },
      })
    },

    AddCourse(row) {
      console.log('课程授权')
      this.$router.push({
        name: 'school-system-permissions',
        query: {
          id: row.id,
          off_time: row.off_time,
          domain: row.domain,
          name: row.name,
        },
      })
    },

    AddAccount(row) {
      console.log('添加校长')
      this.$router.push({
        name: 'principal-management',
        query: {
          id: row.id,
          domain: row.domain,
          name: row.name,
        },
      })
    },
    AddTeach(row) {
      console.log('教师管理')
      this.$router.push({
        name: 'teacher-management',
        query: {
          id: row.id,
          domain: row.domain,
          name: row.name,
        },
      })
    },

    AddSchoolTime(row) {
      this.$router.push({
        name: 'create-order',
        query: {
          id: row.id,
          name: row.name,
        },
      })
    },

    AddData(row) {
      console.log('添加流量')
      this.$router.push({
        name: 'data-management',
        query: {
          id: row.id,
          off_time: row.off_time,
          domain: row.domain,
          name: row.name,
        },
      })
    },

    LookOrder(row) {
      console.log('查询校区订单')
      this.$router.push({
        name: 'look-order',
        query: {
          id: row.id,
        },
      })
    },
    quitDialog1() {
      this.$refs['form1'].resetFields()
      this.dialogVisible1 = false
    },
    quitDialog() {
      this.$refs['form'].resetFields()
      //   this.$refs["form1"].resetFields();

      this.dialogVisible = false
    },
    // 添加合作学校
    addSchool() {
      this.schoolId = ''
      //   this.$refs["form1"].resetFields();

      this.dialogVisible1 = true
      this.form1 = {
        subjectIds: [],
        school_name: '',
        domain: '',
        off_time: '',
        username: '',
        realname: '',
        meal_id: this.form1.meal_id,
      }

      //   this.form = {
      //     educational_institution_name: "",
      //     domain: "",
      //     max_campus_num: 1,
      //     max_teacher_num: 1,
      //     max_student_num: 1,
      //     off_time: "",
      //     remarks: "",
      //     tagIds: [],
      //     province: "",
      //     city: "",
      //     area: "",
      //     question_bank_permission: false
      //   };
    },
    search() {
      this.page_no = 1
      this.getEducationalInstitutionList()
    },
    submit1(formName1) {
      this.$refs[formName1].validate((valid) => {
        if (valid) {
          console.log('新建校区参数')
          console.log(this.form1)
          addTrySchool({
            name: this.form1.school_name,
            domain: this.form1.domain,
            offTime: this.form1.off_time + ' 23:59:59',
            authMealId: this.form1.meal_id,
            questionBankPermission: this.form1.question_bank_permission || false,
            ojPermission: this.form1.oj_permission || false,
            subjectIds: this.form1.subjectIds,
            userName: this.form1.username,
            realName: this.form1.realname,
            // ...this.form1
          }).then((res) => {
            console.log('新增合作校区')
            console.log(res)
            this.$message.success('添加合作学校成功')
            this.quitDialog1()
            this.getEducationalInstitutionList()
          })
        }
      })
    },
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.schoolId) {
            let params = {
              eduId: this.schoolId,
              name: this.form.educational_institution_name,
              domain: this.form.domain,
              subjectIds: this.form.subjectIds,
              offTime: this.form.off_time.split(' ').length === 1 ? this.form.off_time + ' 23:59:59' : this.form.off_time,
              remark: this.form.remarks,
              questionBankPermission: this.form.question_bank_permission || false,
              ojPermission: this.form.oj_permission || false,
            }
            updateTrySchool(params).then((res) => {
              console.log('修改学校信息')
              console.log(res)
              this.$message.success('修改成功')
              this.quitDialog()
              this.getEducationalInstitutionList()
            })
          }
        }
      })
    },
    // 获取合作学校列表
    getEducationalInstitutionList() {
      getEducationalInstitutionList({
        domain: this.ruleForm.domain,
        is_try: 1,
        authUserName: this.ruleForm.authUserName,
        subjectIds: JSON.stringify(this.ruleForm.subjectIds),

        educational_institution_name: this.ruleForm
          .educational_institution_name,
        username: this.ruleForm.username,
        page_no: this.page_no,
      }).then((res) => {
        console.log('校区列表')
        console.log(res)
        this.tableData = res.educational_institution_list
        this.total = res.total
        // for (let i = 0; i < this.tableData.length; i++) {
        //   if (this.tableData[i].authUserInfo) {
        //     console.log(this.tableData[i].authUserInfo.realname)
        //     this.authUserInfoName = this.tableData[i].authUserInfo.realname
        //     console.log(this.authUserInfoName)

        //   } else {

        //     this.tableData[i].push(1);

        //   }

        // }

        for (let k = 0; k < this.tableData.length; k++) {
          this.tableData[k].classlist = []
          for (
            let j = 0;
            j < this.tableData[k].schoolSubjectAuthArr.length;
            j++
          ) {
            this.tableData[k].classlist.push(
              this.tableData[k].schoolSubjectAuthArr[j].subjectInfo.name
            )
          }

          this.tableData[k].subject = this.tableData[k].classlist.join(' , ')
        }
      })
    },

    GogoSchool(domain) {
      console.log('二级域名跳转')
      console.log(domain)
      window.open('https://' + domain + '.steam.fun', '_blank')
    },

    handleCurrentChange(val) {
      this.page_no = val
      this.getEducationalInstitutionList()
    },
  },
}
</script>

<style lang="scss" scoped>
.cooperative-school {
  padding: 20px;
  margin: 10px;
  background-color: #fff;
  border-radius: 5px;

  .form-style {
    margin-left: 15px;
  }

  .btn {
    margin-top: 15px;
  }
}

.cooperative-school .form1 /deep/ .el-form-item {
  margin-bottom: 10px;
}

.table-style {
  margin-top: 20px;
}
</style>
